import Vue from "vue";
import Vuex from "vuex";
import personService from "../api/person";
import router from "../router";

Vue.use(Vuex);

const initialState = {
  personManage: {
    Name: "",
    Breed: "",
    Species: "",
    Gender: "Male",
    DateOfBirth: null,
    DateOfDeath: null,
    Country: "",
    City: "",
    Nickname: "",
    FirstName: "",
    LastName: "",
    Occupation: "",
    PassportId: "",
    ChipId: "",
    UserID: "",
    SubscriptionId: "123456789",
    ActiveUntil: "2042-06-16T10:53:17.2785369Z",
    ImageOriginalName: null,
    ImageName: null,
    GraveLocationCountry: "",
    GraveLocationCity: "",
    GraveLocationDescription: "",
    GraveLocationLat: "",
    GraveLocationLng: "",
    ZodiacSign: "",
    EyeColor: "",
    Height: "",
    Weight: "",
    PackageDueDate: null,
    FavoriteColor: "",
    FavoriteFood: "",
    FavoriteDesert: "",
    FavoriteDrink: "",
    FavoriteToy: "",
    FavoriteBreakfast: "",
    FavoriteLunch: "",
    FavoriteDinner: "",
    FavoriteSnacks: "",
    FavoritePizza: "",
    FavoritePasta: "",
    FavoriteVegetable: "",
    FavoriteFruit: "",
    FavoriteMeat: "",
    FavoriteCake: "",
    FavoriteCoffee: "",
    FavoriteWine: "",
    FavoriteBeer: "",
    FavoriteTea: "",
    FavoriteTravelPlace: "",
    FavoriteMuseum: "",
    FavoriteWaterfall: "",
    FavoriteBeach: "",
    FavoriteLake: "",
    FavoriteSea: "",
    FavoriteOcean: "",
    FavoriteIsland: "",
    FavoriteMountain: "",
    FavoriteRiver: "",
    FavoriteCity: "",
    FavoriteCountry: "",
    FavoriteMovie: "",
    FavoriteMovieGenre: "",
    FavoriteActor: "",
    FavoriteActress: "",
    FavoriteTvShow: "",
    FavoriteCartoon: "",
    FavoriteMarvelMovie: "",
    FavoriteBand: "",
    FavoriteSong: "",
    FavoriteMusicGenre: "",
    FavoriteMaleSinger: "",
    FavoriteFemaleSinger: "",
    FavoriteBook: "",
    FavoriteMaleWriter: "",
    FavoriteFemaleWriter: "",
    FavoriteSportPlayer: "",
    FavoriteSport: "",
    FavoriteDance: "",
    FavoriteCar: "",
    FavoriteGame: "",
    FavoriteHobby: "",
    FavoriteFlower: "",
    PackageName: "",
  },
  packages: [],
  personData: {},
  followerList: [],
  allPersons: [],
  personMetrics: {},
  personMedia: [],
};

const getters = {
  personMedia(state) {
    return state.personMedia;
  },
  personManage(state) {
    return state.personManage;
  },
  packages(state) {
    return state.packages;
  },
  personData(state) {
    return state.personData;
  },
  allPersons(state) {
    return state.allPersons;
  },
  followerList(state) {
    return state.followerList;
  },
  personMetrics(state) {
    return state.personMetrics;
  },
};

export const actions = {
  async getParsonMetrics(context, payload) {
    try {
      const response = await personService.getParsonMetrics(payload);
      context.state.personMetrics = response.data;
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getPackages(context) {
    try {
      const response = await personService.getPackages();
      context.state.packages = response.data;
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getAllPersons(context, payload) {
    try {
      const response = await personService.getAllPersons(payload);
      if (response.status != 204) {
        context.state.allPersons = response.data;
      } else {
        context.state.allPersons = [];
      }
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getPerson(context, payload) {
    try {
      context.state.personData = {};
      const response = await personService.getPerson(payload);
      // response.data.lastGreetings = response.data.lastGreetings.sort((a, b) => new Date(b.dateOfCreate) - new Date(a.dateOfCreate))
      // response.data.timelines = response.data.timelines.sort((a, b) => new Date(a.from) - new Date(b.from))
      // response.data.timelines = response.data.timelines.sort((a, b) => a.from - b.from)
      // response.data.videos = [{}, {}, {}]
      // response.data.images = [{}, {}, {}]
      // response.data.documents = [{}, {}, {}]
      context.state.personData = response.data;
      return Promise.resolve();
    } catch (error) {
      context.state.personData = {};
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getMedia(context, payload) {
    try {
      const response = await personService.getMedia(payload);
      context.state.personMedia = response.data;
      return Promise.resolve();
    } catch (error) {
      context.state.personMedia = [];
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getFollowers(context, payload) {
    try {
      const response = await personService.getFollowers(payload);
      context.state.followerList = response.data.followers;
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async addPerson(context, payload) {
    try {
      const response = await personService.addPerson(payload);
      router.push(`profile/${response.data}`);
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async addPet(context, payload) {
    try {
      const response = await personService.addPet(payload);
      router.push(`profile/${response.data}`);
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async followPerson(context, payload) {
    try {
      const response = await personService.followPerson(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.yourRequestSend,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async updatePerson(context, payload) {
    try {
      const response = await personService.updatePerson(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.changed,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async updatePet(context, payload) {
    try {
      const response = await personService.updatePet(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.changed,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
};

export const state = { ...initialState };

export default {
  namespaced: true,
  state,
  getters,
  actions,
};
